import createAction from 'store/utils/createAction';

const serviceName = 'global';

export const trackAnalyticsEvent = (
  eventName: string,
  payload: any = null
): Promise<never> =>
  new Promise((resolve, reject) => {
    const analyticsReady = Boolean(window.analytics);
    if (analyticsReady) {
      window.analytics.track(eventName, payload, resolve);
    } else {
      reject();
    }
  });

export const identifyUserEvent = (userId: number, data: any) => {
  const analyticsReady = Boolean((global as any).analytics);

  if (analyticsReady) {
    window.analytics.identify(userId, data);
    return true;
  }

  return false;
};

export const setSnackbarMessage = createAction(
  `${serviceName}/SET_SNACKBAR_MESSAGE`
);

export const clearSnackbarMessage = createAction(
  `${serviceName}/CLEAR_SNACKBAR_MESSAGE`
);
